<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { fetchWrapper } from '@/helpers/fetch-wrapper'

const props = defineProps({
  conceptID: {
    type: Number,
    required: true
  }
})

const { t } = useI18n()
const showModal = ref(false)
const selectedIssue = ref('')
const freeFormError = ref('')
const isSubmitting = ref(false)
const submissionSuccess = ref(false)

const issues = [
  { value: 'incorrect-audio', label: t('report.incorrect-audio') },
  { value: 'incorrect-translation', label: t('report.incorrect-translation') },
  { value: 'other', label: t('report.other') }
]

async function submitReport() {
  if (!selectedIssue.value) {
    alert(t('report.select-issue'))
    return
  }

  isSubmitting.value = true
  try {
    const payload = {
      concept_id: props.conceptID,
      issue_type: selectedIssue.value,
      description: selectedIssue.value === 'other' ? freeFormError.value : ''
    }
    await fetchWrapper.post(`/curriculum/concepts/${props.conceptID}/report_issue/`, payload)
    submissionSuccess.value = true
    setTimeout(() => {
      showModal.value = false
      submissionSuccess.value = false
      selectedIssue.value = ''
      freeFormError.value = ''
    }, 2000)
  } catch (error) {
    console.error('Error submitting report:', error)
    alert(t('report.submission-failed'))
  } finally {
    isSubmitting.value = false
  }
}
</script>

<template>
    <div v-if="!submissionSuccess">
      <h3>{{ t('report.select-issue') }}</h3>
      <div>
        <label v-for="issue in issues" :key="issue.value" class="d-block">
          <input
            type="radio"
            :value="issue.value"
            v-model="selectedIssue"
          />
          {{ issue.label }}
        </label>
      </div>
      <div v-if="selectedIssue === 'other'" class="mt-3">
        <textarea
          v-model="freeFormError"
          :placeholder="t('report.describe-issue')"
          rows="4"
          class="form-control"
        ></textarea>
      </div>
      <div class="mt-4">
        <button
          class="btn btn-primary"
          :disabled="isSubmitting"
          @click="submitReport"
        >
          {{ isSubmitting ? t('report.submitting') : t('report.submit') }}
        </button>
      </div>
    </div>
    <div v-else>
      <h3>{{ t('report.submission-success') }}</h3>
    </div>
</template>

<style scoped>
textarea {
  width: 100%;
  resize: none;
}
</style>